export enum SelectorType {
  Airport = "airport",
  Dates = "dates",
  Destination = "destination",
  Category = "category",
}
